import { fetchAuthSession } from 'aws-amplify/auth';
import { isTypedFunction, isString } from '@aws-amplify/ui';
import { resolveFile } from './resolveFile.mjs';

const getInput = ({ accessLevel, file, key, onProcessFileSuccess, onProgress, path, processFile, }) => {
    return async () => {
        const hasCallbackPath = isTypedFunction(path);
        const hasStringPath = isString(path);
        const hasKeyInput = !!accessLevel && !hasCallbackPath;
        const { file: data, key: processedKey, ...rest } = await resolveFile({ file, key, processFile });
        if (processFile) {
            // provide post-processing value of target `key`
            onProcessFileSuccess({ processedKey });
        }
        const contentType = file.type || 'binary/octet-stream';
        // IMPORTANT: always pass `...rest` here for backwards compatibility
        const options = { contentType, onProgress, ...rest };
        if (hasKeyInput) {
            // legacy handling of `path` is to prefix to `fileKey`
            const resolvedKey = hasStringPath
                ? `${path}${processedKey}`
                : processedKey;
            return { data, key: resolvedKey, options: { ...options, accessLevel } };
        }
        const { identityId } = await fetchAuthSession();
        const resolvedPath = `${hasCallbackPath ? path({ identityId }) : path}${processedKey}`;
        return { data: file, path: resolvedPath, options };
    };
};

export { getInput };
